import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";

import { CancellableWorkdayStatus } from "@lib/store/src/data/timeslots/apiTypes";
import { Loader } from "@atoms";
import { workdayLabelMap } from "@lib/logic";
import { cn } from "@utils";
import { WorkdayIcon } from "@molecules";

interface WorkdayStatusButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  status: CancellableWorkdayStatus;
  loading?: boolean;
  buttonClassName?: string;
  iconClassName?: string;

  disabled?: boolean;
  customTitle?: string;
  customSubtitle?: string;
}

export const WorkdayStatusButton = ({
  status,
  loading,
  buttonClassName,
  iconClassName,

  disabled,
  customTitle,
  customSubtitle,
  ...props
}: WorkdayStatusButtonProps) => {
  const { t } = useTranslation();

  return (
    <>
      <button
        type="button"
        disabled={disabled}
        {...props}
        className={`flex items-center justify-center size-10 w-full disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:bg-mapiq-black-800*/[0.03] ${
          buttonClassName || ""
        }`}
        data-tooltip-id={status === "OfficeDay" ? "workday-status-tooltip" : undefined}>
        {loading ? (
          <div className="flex items-center justify-center w-10">
            <Loader size="1rem" />
          </div>
        ) : (
          <WorkdayIcon
            status={status}
            className={cn("h-5", iconClassName)}
          />
        )}

        <span className="font-semibold translate-y-px leading-4 max-sm:hidden">{t(workdayLabelMap[status])}</span>
      </button>

      {status === "OfficeDay" && disabled && customTitle && (
        <Tooltip id="workday-status-tooltip">
          <div className="flex flex-col">
            <p>{customTitle}</p>

            {customSubtitle && <p>{customSubtitle}</p>}
          </div>
        </Tooltip>
      )}
    </>
  );
};
